<template>
  <div class="flex items-center gap-1">
    <span
      class="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded-full flex items-center gap-1"
      v-for="attendee in attendees"
    >
      <vue-feather type="user" class="h-3" />
      <span>{{ attendee }}</span>
    </span>
  </div>
</template>

<script>
import { uniq } from 'lodash';

export default {
  props: {
    eventRecording: {
      type: Object,
    },
  },
  computed: {
    attendees() {
      if (!this.eventRecording) return [];
      if (!this.eventRecording.daily_attendees) return [];

      let distinctAttendees = uniq(this.eventRecording.daily_attendees);

      return distinctAttendees.map(a => a.trim());
    },
  },
};
</script>
